// @flow

import FocusBody from 'components/FocusBody';
import * as React from 'react';
import View from 'components/View';
import { withCookies } from 'react-cookie';
import { homePath, sendEmailBase } from 'WebModule/app/routerPaths';
import LanguageSwitcher from 'WebModule/i18n/LanguageSwitcher';
import { getAllowLanguageSwitch } from 'utils/i18n';
import SendResetEmailPage from 'WebModule/ResetPasswordPage/SendResetEmailPage';
import ResetPassword from 'WebModule/ResetPasswordPage/ResetPasswordPage';
import FocusHeader from '../Registration/components/FocusHeader';
import FocusContent from '../Registration/components/FocusContent';
import { FocusPage } from '../Registration/components/Page';

const styles = {
  focusContentWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  focusContent: {
    margin: '60px'
  },
  pageWrapper: {
    height: '100%',
    position: 'relative'
  },
  languageSwitcherStyles: {
    position: 'absolute',
    top: '10px',
    right: '10px',

    '& select': {
      color: 'silver'
    },

    '& svg': {
      color: 'silver'
    }
  }
};

const Focus = ({ cookies, history, match: { params } }) => {
  const { id } = params;
  const allowLanguageSwitcher = getAllowLanguageSwitch(cookies);

  const returnHome = () => {
    history.push(homePath);
  };

  return (
    <View style={styles.pageWrapper}>
      {allowLanguageSwitcher ? (
        <View style={styles.languageSwitcherStyles}>
          <LanguageSwitcher refreshPage />
        </View>
      ) : null}

      <FocusPage>
        <View style={styles.focusContentWrapper}>
          <FocusContent style={styles.focusContent}>
            <FocusHeader onClose={returnHome} />
            <FocusBody>
              {id === `${sendEmailBase}` ? (
                <SendResetEmailPage returnHome={returnHome} />
              ) : (
                <ResetPassword returnHome={returnHome} code={id} />
              )}
            </FocusBody>
          </FocusContent>
        </View>
      </FocusPage>
    </View>
  );
};

export default withCookies(Focus);
